<template>
    <div class="transcriptions-tab row nav-padding">
        <div class="d-flex align-items-center justify-content-between">
            <div class="px-3">
                <div v-if="company">
                    <div>
                        <span class="_700">ID:</span> #{{ company.id }}
                    </div>
                    <div>
                        <span class="_700">Company:</span> {{ company.name }}
                    </div>
                </div>
            </div>

            <div class="d-flex justify-content-end px-3 pt-3">
                <div class="mr-2">
                    <company-autosuggest 
                        v-model="company_id" 
                        @company-selected="handleCompanySelected"
                    />
                </div>

                <div>
                    <el-button
                        v-if="company_id"
                        @click="clearFilters()">
                        Reset
                    </el-button>
                </div>
            </div>
        </div>

        <div class="w-100 pt-5">
            <div v-if="company" class="p-3">
                <el-card class="box-card">
                    <div slot="header" class="clearfix">
                        <span>Transcription Usage</span>
                    </div>
                    <div class="text-item">
                        <span class="label">Used transcription minutes:</span>
                        <span class="value">{{ company.used_transcription_min || 0 }}</span>
                        <el-button 
                            type="danger" 
                            size="mini" 
                            class="ml-3"
                            :loading="resetting"
                            :disabled="!company.used_transcription_min"
                            @click="resetTranscriptionMinutes">
                            Reset Minutes
                        </el-button>
                    </div>
                    <div class="text-item">
                        <span class="label">Included transcription minutes:</span>
                        <span class="value">
                            <span v-if="company.plan?.unlimited_transcription" class="text-success">
                                <i class="fa fa-infinity"></i> Unlimited
                            </span>
                            <span v-else>{{ company.plan?.included_transcription_min || 0 }}</span>
                        </span>
                    </div>
                    <div class="text-item">
                        <span class="label">Plan:</span>
                        <span class="value">{{ company.plan?.name || 'N/A' }}</span>
                    </div>
                </el-card>
            </div>

            <div v-else class="h-100 d-flex align-items-center">
                <div v-if="loading" class="w-100">
                    <h3 class="text-center">Loading...</h3>
                </div>
                <div v-else class="w-100 search-resource-text">
                    <div class="text-center">
                        <i class="fa fa-search"></i>
                        <p class="mb-0">Select a company to view transcription usage</p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import CompanyAutosuggest from '../company-autosuggest'

export default {
    data() {
        return {
            company: null,
            company_id: null,
            loading: false,
            resetting: false
        }
    },

    components: {
        CompanyAutosuggest
    },

    methods: {
        clearFilters() {
            this.company_id = null
            this.company = null
        },

        handleCompanySelected(company) {
            this.company = company
        },

        resetTranscriptionMinutes() {
            if (!this.company) return

            this.$confirm('Are you sure you want to reset the AVA transcription minutes to 0?', 'Warning', {
                confirmButtonText: 'Yes',
                cancelButtonText: 'No',
                type: 'warning'
            }).then(() => {
                this.resetting = true
                axios.post(`/api/admin/company/${this.company.id}/reset-transcription-minutes`)
                    .then(response => {
                        this.company = response.data.company
                        this.$notify({
                            title: 'Success',
                            message: 'AVA transcription minutes have been reset to 0',
                            type: 'success'
                        })
                    })
                    .catch(error => {
                        this.$notify.error({
                            title: 'Error',
                            message: error.response?.data?.message || 'Failed to reset AVA minutes'
                        })
                    })
                    .finally(() => {
                        this.resetting = false
                    })
            }).catch(() => {})
        }
    }
}
</script>

<style scoped>
.text-item {
    font-size: 16px;
    display: flex;
    align-items: center;
}
.text-item .label {
    font-weight: bold;
    margin-right: 10px;
}
.text-item .value {
    color: #409EFF;
}
</style>
